<div class='h-100'>
  <div class='knobContainer center-child-xy'>



      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 163.31 163.31">

          <g id="back">
              <circle cx="81.65" cy="81.65" r="80" style="fill:#252c33" stroke-width='1'/>
          </g>

          <g id="front" #top class='centerKnob grabbable' (mousedown)='initiateDrag($event);'>
              <circle cx="81.65" cy="81.65" r="52.47" style="fill:#303841" stroke-width='6'/>
              <rect *ngIf="oscillator!.connected" x="77.08" y="102.2" width="9.15" stroke="#fffd47" stroke-width="10" height="30.06" rx="4.5" style="fill:#fffd47"/>
          </g>
      </svg>
  </div>

  <div class='center-child-x knob-value-container'>
    <input class='control knob-value' [ngClass]="{ 'knob-disconnected' : !oscillator!.connected }" [(ngModel)]="output" type='text' readonly/>
  </div>
</div>


